import React, { useRef } from "react";
// import { PaymentMethodCardProps } from "../../payment/PaymentMethods/PaymentMethodsCard/PaymentMethodsCardInterface";
import ConnectButton from "../../payment/PaymentMethods/PaymentMethodsCard/PaymentMethodsButtons/ConnectButton";
// import Loader from "../../common/Loader";
import { useAuth } from "../../../context/AuthContext";
import { dictionary } from "../../../utils/dictionary";
import { IntegrationsCardProps } from "./IntegrationsCardInterface";
import CancelButton from "../../payment/PaymentMethods/PaymentMethodsCard/PaymentMethodsButtons/CancelButton";

const IntegrationsCard: React.FC<IntegrationsCardProps> = ({
  name,
  logoSrc,
  isActive,
  isConnected,
  onConnect,
  onCancel,
  bgColor = "bg-[#EB6F2D]",
  loading,
  type,
}) => {
  const { language } = useAuth();
  const isActiveCorrect = useRef(isActive);
  
  const objectFitClass = type === 'stripe' ? 'object-cover' : 'object-contain';

  return (
    <div className="w-full sm:w-72 p-4 md:p-6 bg-white rounded-[10px] shadow-[4px_4px_15px_0px_rgba(0,0,0,0.2)] flex flex-col justify-between gap-4">
      {/* Encabezado con logo y estado */}
      <div className="flex items-center justify-between w-full">
        {/* Estado visual */}
        <div
          className={`px-2 md:px-3 py-1 text-xs md:text-sm font-semibold rounded-lg ${
            isActiveCorrect.current
              ? "bg-green-200 text-green-700"
              : "bg-red-200 text-red-700"
          }`}
        >
          {isActiveCorrect.current
            ? dictionary["active"][language]
            : dictionary["inactive"][language]}
        </div>
      </div>
      <div
        className={`flex items-center justify-center rounded-lg ${bgColor} w-full h-[100px] relative overflow-hidden`}
      >
        <img
          src={logoSrc as string}
          alt={name}
          className={`w-full h-full ${objectFitClass} ${type === 'stripe' ? '' : 'p-2'}`}
        />
      </div>

      {/* Toggle */}
      {/* {loading ? (
        <div className="flex items-center">
          <span
            className={`mr-2 text-sm ${
              isActiveCorrect.current ? "font-thin text-gray-400" : "font-bold"
            }`}
          >
            {dictionary["off"][language]}
          </span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={isActiveCorrect.current}
              onChange={(e) => handleToggle(e)}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-300 peer-checked:bg-blue-600 transition-colors" />
            <span className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full peer-checked:translate-x-5 transition-transform" />
            <span
              className={`ml-2 text-sm ${
                isActiveCorrect.current
                  ? "font-bold"
                  : "font-thin text-gray-400"
              }`}
            >
              {dictionary["on"][language]}
            </span>
          </label>
        </div>
      ) : (
        <div className="flex items-center justify-center">
          <Loader size={24} />
        </div>
      )} */}

      {/* Botón de conexión dinámico */}

      {isConnected ? (
        <CancelButton onClick={onCancel} loading={loading} />
      ) : (
        <ConnectButton onClick={onConnect} loading={loading} />
      )}
    </div>
  );
};

export default IntegrationsCard;
